import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ChatMessageStatusModalUI from './ChatMessageStatusModalUI.js'

class ChatMessageStatusModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: '',
      statusError: null,
    }
  }

  render() {
    let statusList = [
      { key: 'archived', value: 'archived' },
      { key: 'recent', value: 'recent' }
    ]
    return (
      <ChatMessageStatusModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // 
        status={this.state.status}
        onStatusChange={(event) => { this.setState({ status: event.target.value }) }}
        statusError={this.state.statusError}
        setStatusError={(error) => { this.setState({ statusError: error }) }}
        statusList={statusList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    if (this.props.selectedAccountId) {
      RestApiUtils.put(this.props.context,
        `/api/su/accounts/${this.props.selectedAccountId}/chatMessages/${this.props.selectedMesgDate}/statuses`,
          this.onSubmitCallback, {
          status: this.state.status,
        }
      )
    }

    if (!this.props.selectedAccountId) {
      RestApiUtils.put(this.props.context,
        `/api/su/phoneNumber/${this.props.selectedPhone}/chatMessages/${this.props.selectedMesgDate}/statuses`,
          this.onSubmitCallback, {
          status: this.state.status,
        }
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ChatMessageStatusModalSF)
